// extracted by mini-css-extract-plugin
export default {"container":"SkillCard_container__41Zti","section":"SkillCard_section__2DH1Z"};